'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { CheckmarkCircle02IconSolid, Clock01IconSolid, SquareLock02IconSolid } from '@/components/ui/icon/glyphs';
import { InfoModal } from '@/components/ui/info-modal';
import { levelForDays, STREAK_TIERS } from '@/lib/streaks';
import { cn } from '@/lib/ui/utils';
import { TierEmblem } from './tier-emblem';
interface StreakLevelsSheetProps {
  currentStreak: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export function StreakLevelsSheet(t0) {
  const $ = _c(17);
  const {
    currentStreak,
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("streaks");
  const level = levelForDays(currentStreak);
  let t1;
  if ($[0] !== t) {
    t1 = t("levels_title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== currentStreak || $[3] !== t) {
    t2 = t("milestones_description", {
      count: currentStreak
    });
    $[2] = currentStreak;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== currentStreak || $[6] !== level || $[7] !== t) {
    t3 = STREAK_TIERS.map(tier => {
      const isCurrent = tier.level === level;
      const isReached = tier.level < level;
      const isNext = tier.level === level + 1;
      return <div key={tier.level} className={cn("flex items-center gap-3 rounded-panel-row border p-3", isCurrent ? "border-feedback-warning-border bg-feedback-warning-surface" : "border-transparent")}><TierEmblem level={tier.level} size={48} className="shrink-0" /><div className="min-w-0 flex-1"><div className="text-body font-medium">{t(`tiers.${tier.slug}`)}</div><div className="text-caption text-foreground-secondary">{t("milestone_unlock", {
              count: tier.minDays
            })}</div></div><span className={cn("inline-flex shrink-0 items-center gap-1.5 text-caption", isCurrent ? "text-feedback-warning-content" : isNext ? "text-foreground-secondary" : "text-foreground-tertiary")}>{isCurrent ? t("current") : isReached ? t("reached") : isNext ? t("days_away", {
            count: tier.minDays - currentStreak
          }) : t("locked")}<Icon icon={isCurrent || isReached ? CheckmarkCircle02IconSolid : isNext ? Clock01IconSolid : SquareLock02IconSolid} className="size-icon-sm" aria-hidden={true} /></span></div>;
    });
    $[5] = currentStreak;
    $[6] = level;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="flex flex-col gap-2">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== onOpenChange || $[12] !== open || $[13] !== t1 || $[14] !== t2 || $[15] !== t4) {
    t5 = <InfoModal open={open} onOpenChange={onOpenChange} size="default" title={t1} description={t2}>{t4}</InfoModal>;
    $[11] = onOpenChange;
    $[12] = open;
    $[13] = t1;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}